/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { PasswordInput, TextInput } from 'carbon-components-react';
import _ from 'lodash';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { useFormHelpers } from '../../hooks/useFormHelpers';
import { ChannelContentProps } from '../../util/types';
import { messages } from './messages';

interface TwilioAuthProps extends ChannelContentProps {
  accountSidField?: string;
  authTokenField?: string;
  isAccountSidPublic?: boolean;
  isQuickSetup?: boolean;
  readOnly?: boolean;
}
export const TwilioAuth = ({
  accountSidField,
  authTokenField,
  isAccountSidPublic,
  isQuickSetup,
  readOnly
}: TwilioAuthProps) => {
  const formMethods = useFormContext();
  const { registerInputField } = useFormHelpers(formMethods);

  const accountSidChangeState = useState<boolean>(false);
  const authTokenChangeState = useState<boolean>(false);

  return (
    <div className="TabContent__field-section">
      {!_.isNil(accountSidField) && (
        <div className="TabContent__field-container">
          {isAccountSidPublic ? (
            <TextInput
              {...registerInputField({
                field: accountSidField,
                isPasswordField: false,
                isQuickSetup,
                labelText: messages.accountSidLabel,
                placeholderText: messages.accountSidPlaceholder,
                changeState: accountSidChangeState,
                readOnly
              })}
            />
          ) : (
            <PasswordInput
              {...registerInputField({
                field: accountSidField,
                isPasswordField: true,
                isQuickSetup,
                labelText: messages.accountSidLabel,
                placeholderText: messages.accountSidPlaceholder,
                changeState: accountSidChangeState,
                readOnly
              })}
            />
          )}
        </div>
      )}
      {!_.isNil(accountSidField) && !_.isNil(authTokenField) && (
        <div className="TabContent__spacer16" />
      )}
      {!_.isNil(authTokenField) && (
        <div className="TabContent__field-container">
          <PasswordInput
            {...registerInputField({
              field: authTokenField,
              isPasswordField: true,
              isQuickSetup,
              labelText: messages.authTokenLabel,
              placeholderText: messages.authTokenPlaceholder,
              changeState: authTokenChangeState,
              readOnly
            })}
          />
        </div>
      )}
      {!_.isNil(accountSidField) && !_.isNil(authTokenField) && (
        <div className="TabContent__spacer-16" />
      )}
    </div>
  );
};
